var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".s{fill:url(#e);}.t{fill:url(#r);}.u{fill:url(#i);}.v{fill:url(#h);}.w{fill:url(#c);}.x{fill:url(#b);}.y,.a`{mix-blend-mode:overlay;}.y,.aa{opacity:.29;}.ab,.aa{fill:#9cd6f4;}.ac{fill:#37aadf;}.ad{stroke:url(#n);stroke-width:1.19px;}.ad,.ae,.af{fill:none;stroke-miterlimit:10;}.ae{stroke:#fff;stroke-width:1.71px;}.ag{filter:url(#l);}.ag,.ah{fill:#fbfbfd;}.ah{filter:url(#j);}.ai{mix-blend-mode:multiply;}.af{stroke:url(#d);stroke-width:1.79px;}.aj,.ak,.al,.am,.an,.ao,.ap,.aq{mix-blend-mode:screen;}.ak{opacity:.68;}.al{opacity:.79;}.am{fill:url(#g);}.an{fill:url(#f);}.ao{fill:url(#q);}.ap{fill:url(#p);}.aq{fill:url(#o);}.ar{isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 207.41,
    y1: 329.64,
    x2: 207.41,
    y2: 44.69,
    gradientTransform: "translate(202.28 -88.04) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#004d94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#008ed0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 353.22,
    y1: 183.7,
    x2: 307.46,
    y2: 111.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#e5f8ff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#a2e7ff",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#38ccff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2ec9ff",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#86e0ff",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#c7f0ff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#effbff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 64.04,
    y1: 200.15,
    x2: 350.78,
    y2: 200.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#038ece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#279fd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#52b4e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#77c6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#93d3f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#a7ddf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b3e3f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b7e5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#93ceec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5faed8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3694c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1881be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0676b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0072b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#47a2d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#84cbed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9cdbf7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 120.94,
    y1: 283.51,
    x2: 120.94,
    y2: 75.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#c6f0ff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#92e3ff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#65d7ff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40ceff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#24c7ff",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#10c2ff",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#04bfff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#02beff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#09c0ff",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#15c3ff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#27c8ff",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#3ecdff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5bd5ff",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7dddff",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#a4e8ff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d0f3ff",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 248.3,
    y1: 348.3,
    x2: 350.96,
    y2: 250.14,
    gradientTransform: "translate(-11.96 1.5) rotate(-.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fcfeff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a4e7ff",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5dd5ff",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2bc8ff",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0bc0ff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0bc1ff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2bc9ff",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#5ed6ff",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a5e8ff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 295.68,
    y1: 1105.05,
    x2: 295.68,
    y2: 765.37,
    gradientTransform: "translate(-11.96 1.5) rotate(-.92)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 231.49,
    y1: 195.48,
    x2: 252.59,
    y2: 252.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#00b7ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#00aee6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 191.26,
    y1: 148.97,
    x2: 228.49,
    y2: 234.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afd9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#a8d7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#97d3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7acceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#52c2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#20b5e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00aee6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.03,
    dy: 2.03
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "k",
    stdDeviation: 4.05
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#217ead",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "k",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.03,
    dy: 2.03
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "m",
    stdDeviation: 4.05
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#217ead",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "m",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 181.9,
    y1: 125.76,
    x2: 244.94,
    y2: 270.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#038ece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ba7d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6ebee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9ad2eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#bee2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#dbeef8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eff7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fbfdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#d4e7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#94c4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5fa6d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#368fc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#187fbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0675b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0072b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#47a2d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#84cbed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9cdbf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#67bae3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#027bbe"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 1415.95,
    cy: -42.67,
    fx: 1415.95,
    fy: -42.67,
    r: 20.48,
    gradientTransform: "translate(-1274.26 233.28) rotate(-.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e4e4e4",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#b4b4b4",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#898989",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#646464",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#454545",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2b2b2b",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#181818",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0a0a0a",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#020202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: -12040.03,
    cy: 513.75,
    fx: -12040.03,
    fy: 513.75,
    r: 12.37,
    gradientTransform: "translate(1055.78 1080.89) rotate(89.68) scale(.08 1.77) skewX(-.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fefcf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#fbf3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f7e6be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f1d48d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#eabd4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#e6af2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e29c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#df8a27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#d38224",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a2641c",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#764914",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#52320e",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#342009",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#1d1205",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0c0702",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030100",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: -9084.5,
    cy: 1444.68,
    fx: -9084.5,
    fy: 1444.68,
    r: 12.37,
    gradientTransform: "translate(-525.98 2743.64) rotate(179.68) scale(.08 1.77) skewX(-.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d3d3d3",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#a2a2a2",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#767676",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#525252",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#343434",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#1d1d1d",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0c0c0c",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030303",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 40.92,
    y1: 337.54,
    x2: 80.09,
    y2: 337.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6ac7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0ab0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#00aee6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ai"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 207.41,
    cy: 200.15,
    r: 161.34,
    transform: "translate(-80.78 205.29) rotate(-45)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "x",
    cx: 207.41,
    cy: 200.15,
    r: 142.47,
    transform: "translate(-80.78 205.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "y"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 198.53,
    y1: 73.14,
    x2: 199.37,
    y2: 85.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 189.69,
    y1: 74.07,
    x2: 191.37,
    y2: 85.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 180.94,
    y1: 75.62,
    x2: 183.44,
    y2: 87.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 172.32,
    y1: 77.77,
    x2: 175.63,
    y2: 89.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 163.87,
    y1: 80.51,
    x2: 167.98,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 155.63,
    y1: 83.84,
    x2: 160.51,
    y2: 94.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 147.64,
    y1: 87.74,
    x2: 153.28,
    y2: 98.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 139.95,
    y1: 92.18,
    x2: 146.31,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 132.58,
    y1: 97.15,
    x2: 139.64,
    y2: 106.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 125.58,
    y1: 102.62,
    x2: 133.3,
    y2: 111.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 118.97,
    y1: 108.57,
    x2: 127.32,
    y2: 117.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 112.8,
    y1: 114.96,
    x2: 121.72,
    y2: 123
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 107.09,
    y1: 121.77,
    x2: 116.55,
    y2: 129.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 101.86,
    y1: 128.96,
    x2: 111.82,
    y2: 135.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 97.15,
    y1: 136.49,
    x2: 107.56,
    y2: 142.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 92.98,
    y1: 144.34,
    x2: 103.78,
    y2: 149.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 89.37,
    y1: 152.46,
    x2: 100.5,
    y2: 156.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 86.33,
    y1: 160.81,
    x2: 97.75,
    y2: 164.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 83.88,
    y1: 169.35,
    x2: 95.53,
    y2: 172.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 82.03,
    y1: 178.04,
    x2: 93.86,
    y2: 180.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 80.79,
    y1: 186.84,
    x2: 92.74,
    y2: 188.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 80.18,
    y1: 195.71,
    x2: 92.18,
    y2: 196.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 80.18,
    y1: 204.59,
    x2: 92.18,
    y2: 204.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 80.79,
    y1: 213.46,
    x2: 92.74,
    y2: 212.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 82.03,
    y1: 222.26,
    x2: 93.86,
    y2: 220.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 83.88,
    y1: 230.95,
    x2: 95.53,
    y2: 228.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 86.33,
    y1: 239.49,
    x2: 97.75,
    y2: 235.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 89.37,
    y1: 247.84,
    x2: 100.5,
    y2: 243.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 92.98,
    y1: 255.96,
    x2: 103.78,
    y2: 250.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 97.15,
    y1: 263.81,
    x2: 107.56,
    y2: 257.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 101.86,
    y1: 271.34,
    x2: 111.82,
    y2: 264.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 107.09,
    y1: 278.53,
    x2: 116.55,
    y2: 271.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 112.8,
    y1: 285.34,
    x2: 121.72,
    y2: 277.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 118.97,
    y1: 291.73,
    x2: 127.32,
    y2: 283.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 125.58,
    y1: 297.68,
    x2: 133.3,
    y2: 288.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 132.58,
    y1: 303.15,
    x2: 139.64,
    y2: 293.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 139.95,
    y1: 308.12,
    x2: 146.31,
    y2: 297.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 147.64,
    y1: 312.56,
    x2: 153.28,
    y2: 301.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 155.63,
    y1: 316.46,
    x2: 160.51,
    y2: 305.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 163.87,
    y1: 319.79,
    x2: 167.98,
    y2: 308.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 172.32,
    y1: 322.53,
    x2: 175.63,
    y2: 310.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 180.94,
    y1: 324.68,
    x2: 183.44,
    y2: 312.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 189.69,
    y1: 326.23,
    x2: 191.37,
    y2: 314.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 198.53,
    y1: 327.15,
    x2: 199.37,
    y2: 315.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 207.41,
    y1: 327.46,
    x2: 207.41,
    y2: 315.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 216.29,
    y1: 327.15,
    x2: 215.46,
    y2: 315.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 225.13,
    y1: 326.23,
    x2: 223.46,
    y2: 314.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 233.88,
    y1: 324.68,
    x2: 231.39,
    y2: 312.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 242.51,
    y1: 322.53,
    x2: 239.19,
    y2: 310.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 250.96,
    y1: 319.79,
    x2: 246.85,
    y2: 308.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 259.2,
    y1: 316.46,
    x2: 254.31,
    y2: 305.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 267.18,
    y1: 312.56,
    x2: 261.54,
    y2: 301.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 274.88,
    y1: 308.12,
    x2: 268.51,
    y2: 297.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 282.25,
    y1: 303.15,
    x2: 275.19,
    y2: 293.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 289.25,
    y1: 297.68,
    x2: 281.53,
    y2: 288.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 207.41,
    y1: 72.83,
    x2: 207.41,
    y2: 84.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 295.85,
    y1: 291.73,
    x2: 287.51,
    y2: 283.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 302.03,
    y1: 285.34,
    x2: 293.1,
    y2: 277.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 307.74,
    y1: 278.53,
    x2: 298.27,
    y2: 271.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 312.96,
    y1: 271.34,
    x2: 303,
    y2: 264.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 317.67,
    y1: 263.81,
    x2: 307.27,
    y2: 257.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 321.84,
    y1: 255.96,
    x2: 311.05,
    y2: 250.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 325.46,
    y1: 247.84,
    x2: 314.32,
    y2: 243.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 328.5,
    y1: 239.49,
    x2: 317.07,
    y2: 235.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 330.95,
    y1: 230.95,
    x2: 319.29,
    y2: 228.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 332.79,
    y1: 222.26,
    x2: 320.96,
    y2: 220.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 334.03,
    y1: 213.46,
    x2: 322.08,
    y2: 212.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 334.65,
    y1: 204.59,
    x2: 322.65,
    y2: 204.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 334.65,
    y1: 195.71,
    x2: 322.65,
    y2: 196.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 334.03,
    y1: 186.84,
    x2: 322.08,
    y2: 188.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 332.79,
    y1: 178.04,
    x2: 320.96,
    y2: 180.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 330.95,
    y1: 169.35,
    x2: 319.29,
    y2: 172.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 328.5,
    y1: 160.81,
    x2: 317.07,
    y2: 164.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 325.46,
    y1: 152.46,
    x2: 314.32,
    y2: 156.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 321.84,
    y1: 144.34,
    x2: 311.05,
    y2: 149.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 317.67,
    y1: 136.49,
    x2: 307.27,
    y2: 142.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 312.96,
    y1: 128.96,
    x2: 303,
    y2: 135.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 307.74,
    y1: 121.77,
    x2: 298.27,
    y2: 129.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 302.03,
    y1: 114.96,
    x2: 293.1,
    y2: 123
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 295.85,
    y1: 108.57,
    x2: 287.51,
    y2: 117.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 289.25,
    y1: 102.62,
    x2: 281.53,
    y2: 111.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 282.25,
    y1: 97.15,
    x2: 275.19,
    y2: 106.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 274.88,
    y1: 92.18,
    x2: 268.51,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 267.18,
    y1: 87.74,
    x2: 261.54,
    y2: 98.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 259.2,
    y1: 83.84,
    x2: 254.31,
    y2: 94.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 250.96,
    y1: 80.51,
    x2: 246.85,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 242.51,
    y1: 77.77,
    x2: 239.19,
    y2: 89.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 233.88,
    y1: 75.62,
    x2: 231.39,
    y2: 87.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 225.13,
    y1: 74.07,
    x2: 223.46,
    y2: 85.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x1: 216.29,
    y1: 73.14,
    x2: 215.46,
    y2: 85.13
  }))), /*#__PURE__*/React.createElement("g", {
    className: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M354.16,196.78l-10.69,.03c-.33-17.75-4.22-35.6-11.3-51.76-7.06-16.17-17.5-31.16-30.25-43.5l7.3-7.81c13.81,13.32,25.11,29.54,32.75,47.03,7.67,17.48,11.86,36.8,12.19,56Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "af",
    cx: 207.41,
    cy: 200.15,
    r: 142.47
  }), /*#__PURE__*/React.createElement("g", {
    className: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M134.75,314.54l-5.57,9.13c-24.37-15.37-44.15-38.18-55.83-64.44-12.03-26.76-15.66-57.56-10.22-86.75,5.33-29.01,19.84-56.42,40.87-77.2,20.48-20.37,47.16-34.49,75.34-39.9l1.87,10.53c-26.06,5.04-50.73,18.11-69.68,36.96-19.5,19.27-32.95,44.69-37.89,71.58-5.05,27.08-1.68,55.65,9.47,80.44,10.81,24.3,29.1,45.41,51.64,59.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "al"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M307.61,306.67c-21.63,20.94-49.91,34.82-79.84,39.23l-1.41-10.6c27.69-4.12,53.85-16.98,73.86-36.35,20.35-19.52,34.29-45.12,39.42-72.28l10.53,1.85c-5.51,29.39-20.57,57.07-42.56,78.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M350.17,228.52c-5.51,29.39-20.57,57.07-42.56,78.15-21.63,20.94-49.91,34.82-79.84,39.23l-1.41-10.6c27.69-4.12,53.85-16.98,73.86-36.35,20.35-19.52,34.29-45.12,39.42-72.28l10.53,1.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M233.88,265.88c-18.5,10.53-26.05,13.95-26.05,13.95v-9.98c3.83-1.95,10.81-5.62,21.48-11.69,30.72-18.24,30.67-38.39,30.65-39.08v-16.69h-52.13l61.08-53.86v70.06s1.43,25.65-35.03,47.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M259.96,219.09c.02,.69,.07,20.84-30.65,39.08-10.67,6.07-17.65,9.74-21.48,11.69v9.98s-7.55-3.43-26.07-13.95c-36.46-21.65-35.03-47.29-35.03-47.29v-70.06l61.1-13.67,61.08,13.67-61.08,53.86h52.13v16.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M229.31,258.17c-10.67,6.07-17.65,9.74-21.48,11.69v-67.46h52.13v16.69c.02,.69,.07,20.84-30.65,39.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ag",
    points: "207.83 144.05 155.7 155.72 155.7 202.39 207.83 202.39 207.83 144.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M205.6,284.75c-.32-.14-7.98-3.65-26.51-14.18-37.64-22.35-37.85-49.27-37.76-52.09v-74.28l66.5-14.88,66.48,14.88v74.28c.09,2.81-.12,29.74-37.67,52.03-18.59,10.57-26.25,14.08-26.57,14.23l-2.23,1.02-2.23-1.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a`"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.82 204.31 338.93 200.15 339.85 200.15 339.74 204.34 338.82 204.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.75 206.98 338.81 204.9 339.73 204.93 339.67 207.03 338.75 206.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.64 208.4 338.7 207.71 339.61 207.76 339.56 208.46 338.64 208.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.54 209.72 338.57 209.38 339.49 209.44 339.46 209.79 338.54 209.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 338.77,
    y: 210.04,
    width: 0.35,
    height: 0.92,
    transform: "translate(103.45 532.58) rotate(-85.67)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.4 211.56 338.43 211.21 339.35 211.29 339.32 211.64 338.4 211.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.33 212.48 338.36 212.13 339.28 212.21 339.25 212.56 338.33 212.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.11 214.65 338.16 214.3 339.07 214.4 339.03 214.75 338.11 214.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 338.08,
    y: 216.75,
    width: 0.35,
    height: 0.92,
    transform: "translate(80.16 525.4) rotate(-82.76)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "337.18 221.46 337.42 220.1 337.6 218.73 338.51 218.86 338.33 220.24 338.09 221.61 337.18 221.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "336.55 225 336.92 222.95 337.82 223.1 337.45 225.17 336.55 225"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "336.1 227.34 336.25 226.7 336.36 226.05 337.27 226.23 337.15 226.88 337 227.53 336.1 227.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "335.61 229.45 335.76 228.81 336.66 229.01 336.51 229.66 335.61 229.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "335.26 230.98 335.41 230.33 336.3 230.54 336.15 231.19 335.26 230.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "335.01 232.05 335.11 231.62 336 231.84 335.9 232.27 335.01 232.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M334.7,233.33c.04-.14,.08-.28,.11-.42l.89,.23c-.03,.14-.08,.28-.11,.42l-.89-.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "334.34 234.59 334.46 234.17 335.35 234.41 335.23 234.83 334.34 234.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "333.98 235.86 334.1 235.44 334.99 235.68 334.87 236.11 333.98 235.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "333.62 237.12 333.74 236.7 334.62 236.96 334.5 237.38 333.62 237.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "333.26 238.39 333.38 237.97 334.26 238.23 334.14 238.65 333.26 238.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "332.53 240.68 332.6 240.48 333.48 240.76 333.41 240.97 332.53 240.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 332.3,
    y: 242.02,
    width: 0.22,
    height: 0.92,
    transform: "translate(-3.85 479.6) rotate(-71.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "331.34 244.19 331.41 243.98 332.28 244.29 332.21 244.5 331.34 244.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "330.72 245.93 330.8 245.73 331.67 246.05 331.59 246.25 330.72 245.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "330.04 247.65 330.13 247.45 330.98 247.78 330.9 247.99 330.04 247.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M328.51,251.52c.53-1.28,1.02-2.58,1.53-3.86l.86,.33c-.52,1.3-1.01,2.6-1.55,3.89l-.85-.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "327.41 253.96 328.26 252.06 329.11 252.43 328.25 254.33 327.41 253.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "326.82 255.26 327.11 254.62 327.94 255 327.65 255.65 326.82 255.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "326.27 256.47 326.42 256.15 327.25 256.54 327.11 256.86 326.27 256.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M325.89,257.3c.06-.1,.1-.21,.15-.32l.83,.4c-.05,.11-.1,.21-.15,.32l-.83-.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "325.47 258.12 325.63 257.81 326.46 258.21 326.3 258.53 325.47 258.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "325.05 258.94 325.21 258.63 326.03 259.04 325.87 259.35 325.05 258.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "324.06 260.88 324.21 260.57 325.03 260.99 324.87 261.31 324.06 260.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "322.8 263.27 322.98 262.97 323.79 263.41 323.61 263.71 322.8 263.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "320.72 266.89 322.1 264.5 322.9 264.95 321.51 267.36 320.72 266.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M318.85,269.96c.37-.59,.76-1.17,1.12-1.76l.79,.48c-.36,.6-.75,1.18-1.13,1.77l-.78-.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "317.56 271.97 318.27 270.86 319.05 271.35 318.33 272.47 317.56 271.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M316.39,273.79c.13-.18,.24-.37,.36-.55l.76,.51c-.12,.19-.23,.38-.36,.56l-.76-.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "315.48 275.07 315.86 274.53 316.62 275.05 316.24 275.59 315.48 275.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "314.84 275.96 315.09 275.61 315.85 276.14 315.59 276.5 314.84 275.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "314.08 277.04 314.33 276.68 315.08 277.22 314.83 277.57 314.08 277.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "313.32 278.11 313.57 277.75 314.31 278.3 314.06 278.65 313.32 278.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "312.54 279.17 312.81 278.82 313.55 279.37 313.27 279.72 312.54 279.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "311.73 280.2 312 279.86 312.73 280.42 312.46 280.76 311.73 280.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 311.19,
    y: 280.89,
    width: 0.44,
    height: 0.92,
    transform: "translate(-102.22 352.36) rotate(-51.84)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "309.42 283.13 309.56 282.96 310.27 283.54 310.14 283.71 309.42 283.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "308.24 284.56 308.39 284.39 309.09 284.98 308.95 285.15 308.24 284.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "307.03 285.96 307.17 285.79 307.87 286.39 307.73 286.56 307.03 285.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "305.82 287.35 305.96 287.19 306.65 287.8 306.51 287.96 305.82 287.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "304.6 288.74 304.75 288.59 305.43 289.21 305.28 289.37 304.6 288.74"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "301.73 291.76 304.6 288.75 305.28 289.37 302.39 292.4 301.73 291.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M299.86,293.67c.51-.47,.98-.98,1.46-1.48l.66,.64c-.48,.5-.96,1.02-1.47,1.49l-.65-.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "298.82 294.65 299.33 294.17 299.97 294.83 299.46 295.31 298.82 294.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 298.13,
    y: 295.32,
    width: 0.35,
    height: 0.92,
    transform: "translate(-121.7 287.66) rotate(-43.65)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "297.2 296.2 297.45 295.96 298.08 296.63 297.83 296.87 297.2 296.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "296.53 296.84 296.79 296.59 297.41 297.27 297.16 297.51 296.53 296.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "295.87 297.47 296.12 297.23 296.74 297.91 296.49 298.15 295.87 297.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "294.22 298.9 294.48 298.67 295.09 299.36 294.83 299.59 294.22 298.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "292.18 300.67 292.44 300.44 293.04 301.14 292.77 301.37 292.18 300.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "288.94 303.3 291.11 301.59 291.7 302.3 289.51 304.02 288.94 303.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "286.11 305.53 287.75 304.24 288.31 304.97 286.66 306.26 286.11 305.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "284.17 306.91 285.25 306.14 285.79 306.88 284.71 307.65 284.17 306.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "282.4 308.16 282.94 307.78 283.47 308.54 282.93 308.92 282.4 308.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "281.13 309.07 281.66 308.69 282.19 309.45 281.64 309.83 281.13 309.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "280.21 309.67 280.57 309.44 281.09 310.2 280.72 310.44 280.21 309.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "279.1 310.38 279.47 310.15 279.97 310.92 279.6 311.16 279.1 310.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 278.2,
    y: 310.9,
    width: 0.44,
    height: 0.92,
    transform: "translate(-124 199.47) rotate(-32.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "276.88 311.8 277.25 311.57 277.74 312.35 277.37 312.59 276.88 311.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "275.78 312.51 276.15 312.28 276.63 313.06 276.26 313.3 275.78 312.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "274.64 313.18 275.02 312.96 275.49 313.75 275.11 313.97 274.64 313.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 272.76,
    y: 314.26,
    width: 0.22,
    height: 0.92,
    transform: "translate(-120.55 177.87) rotate(-29.89)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "270.95 315.3 271.14 315.19 271.58 316 271.39 316.11 270.95 315.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "269.32 316.19 269.52 316.09 269.95 316.9 269.76 317 269.32 316.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "267.68 317.03 267.87 316.93 268.29 317.75 268.1 317.85 267.68 317.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "266.03 317.87 266.22 317.77 266.64 318.6 266.44 318.7 266.03 317.87"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M262.28,319.67l1.89-.86c.63-.29,1.24-.63,1.86-.94l.41,.82c-.62,.31-1.24,.65-1.87,.94l-1.91,.86-.38-.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "259.84 320.77 261.73 319.91 262.12 320.75 260.21 321.61 259.84 320.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M258.54,321.35c.22-.09,.43-.19,.64-.28l.36,.85c-.21,.1-.43,.2-.64,.29l-.36-.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "257.3 321.84 257.63 321.71 257.98 322.56 257.65 322.69 257.3 321.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "256.45 322.18 256.77 322.05 257.12 322.9 256.79 323.03 256.45 322.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 255.75,
    y: 322.42,
    width: 0.35,
    height: 0.92,
    transform: "translate(-100.55 116.3) rotate(-21.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "254.74 322.85 255.06 322.72 255.4 323.58 255.07 323.71 254.74 322.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "252.71 323.65 253.03 323.52 253.35 324.39 253.02 324.52 252.71 323.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "250.15 324.52 250.48 324.41 250.78 325.28 250.45 325.39 250.15 324.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M246.19,325.84c.88-.26,1.75-.58,2.62-.87l.29,.87c-.88,.29-1.75,.61-2.64,.88l-.27-.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "242.73 326.83 244.74 326.26 245 327.14 242.97 327.71 242.73 326.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "240.44 327.48 241.71 327.12 241.95 328.01 240.67 328.37 240.44 327.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "238.32 327.97 238.97 327.83 239.19 328.72 238.54 328.87 238.32 327.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "236.8 328.33 237.44 328.18 237.65 329.07 237.01 329.22 236.8 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "235.73 328.57 236.15 328.47 236.35 329.37 235.93 329.47 235.73 328.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "234.45 328.87 234.87 328.77 235.06 329.67 234.64 329.77 234.45 328.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "233.16 329.13 233.59 329.05 233.77 329.95 233.34 330.03 233.16 329.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "231.86 329.36 232.29 329.28 232.47 330.19 232.03 330.26 231.86 329.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 230.65,
    y: 329.54,
    width: 0.44,
    height: 0.92,
    transform: "translate(-54.42 45.73) rotate(-10.13)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "229.27 329.82 229.7 329.74 229.86 330.65 229.43 330.73 229.27 329.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "226.89 330.22 227.11 330.19 227.25 331.1 227.03 331.13 226.89 330.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "225.06 330.45 225.28 330.42 225.4 331.33 225.18 331.36 225.06 330.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "223.22 330.68 223.44 330.66 223.55 331.57 223.33 331.6 223.22 330.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "221.39 330.92 221.6 330.89 221.7 331.8 221.48 331.83 221.39 330.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "219.55 331.08 219.76 331.07 219.85 331.98 219.63 332 219.55 331.08"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "215.4 331.4 219.54 331.08 219.63 332 215.45 332.32 215.4 331.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M212.73,331.53c.69-.02,1.39-.02,2.08-.08l.05,.92c-.7,.07-1.39,.06-2.09,.08l-.04-.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "211.3 331.56 212 331.55 212.03 332.47 211.32 332.48 211.3 331.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "209.97 331.6 210.32 331.59 210.34 332.51 209.99 332.52 209.97 331.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "209.05 331.62 209.4 331.61 209.42 332.53 209.07 332.54 209.05 331.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "208.14 331.64 208.48 331.64 208.49 332.56 208.14 332.57 208.14 331.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M207.22,331.66c.12,0,.23,0,.35,0v.92c-.12,0-.23,0-.35,0v-.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "205.03 331.6 205.38 331.61 205.37 332.53 205.02 332.52 205.03 331.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "202.34 331.53 202.68 331.54 202.65 332.46 202.3 332.45 202.34 331.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M198.17,331.3c.92,.06,1.84,.15,2.76,.2l-.04,.92c-.93-.04-1.85-.13-2.77-.2l.06-.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "194.58 331.03 196.66 331.19 196.58 332.11 194.49 331.95 194.58 331.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "192.21 330.76 193.52 330.93 193.43 331.84 192.11 331.68 192.21 330.76"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 189.87,
    y: 330.65,
    width: 0.92,
    height: 0.66,
    transform: "translate(-162.02 478.05) rotate(-82.75)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "188.51 330.29 189.16 330.37 189.04 331.29 188.38 331.2 188.51 330.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "187.42 330.15 187.85 330.21 187.71 331.12 187.28 331.06 187.42 330.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "186.12 329.92 186.55 330 186.41 330.91 185.97 330.83 186.12 329.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "184.83 329.69 185.26 329.77 185.1 330.68 184.67 330.6 184.83 329.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "183.53 329.46 183.96 329.54 183.8 330.44 183.36 330.37 183.53 329.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "182.24 329.23 182.67 329.31 182.49 330.21 182.06 330.13 182.24 329.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "180.94 329 181.37 329.07 181.19 329.98 180.76 329.9 180.94 329"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "178.59 328.46 178.8 328.51 178.6 329.4 178.39 329.36 178.59 328.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "176.79 328.04 177 328.09 176.79 328.99 176.57 328.94 176.79 328.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "174.99 327.62 175.2 327.67 174.97 328.57 174.76 328.52 174.99 327.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "173.2 327.14 173.41 327.2 173.17 328.09 172.96 328.03 173.2 327.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 170.94,
    y: 327,
    width: 0.92,
    height: 0.22,
    transform: "translate(-190.09 402.62) rotate(-74.14)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M167.43,325.46c.33,.11,.65,.23,.99,.33l1,.28,2,.57-.25,.89-2.01-.57-1.01-.29c-.33-.1-.66-.22-.99-.33l.28-.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "164.9 324.6 166.87 325.27 166.58 326.14 164.6 325.47 164.9 324.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "163.54 324.14 164.21 324.36 163.9 325.23 163.24 325.01 163.54 324.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "162.29 323.72 162.62 323.83 162.31 324.69 161.97 324.58 162.29 323.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "161.43 323.38 161.76 323.51 161.44 324.38 161.11 324.25 161.43 323.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "160.58 323.05 160.9 323.17 160.58 324.04 160.25 323.91 160.58 323.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "159.72 322.71 160.05 322.84 159.72 323.7 159.39 323.57 159.72 322.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "157.69 321.91 158.02 322.04 157.67 322.89 157.34 322.76 157.69 321.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "155.2 320.87 155.52 321.01 155.16 321.86 154.84 321.71 155.2 320.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "151.4 319.15 153.91 320.29 153.54 321.13 151 319.98 151.4 319.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "148.17 317.56 150.03 318.51 149.62 319.34 147.75 318.38 148.17 317.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "146.05 316.47 147.22 317.07 146.8 317.89 145.62 317.28 146.05 316.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "144.13 315.45 144.71 315.78 144.27 316.59 143.69 316.26 144.13 315.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "142.78 314.67 143.35 315 142.9 315.8 142.32 315.47 142.78 314.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "141.82 314.12 142.2 314.34 141.75 315.14 141.36 314.92 141.82 314.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "140.68 313.47 141.06 313.69 140.6 314.48 140.22 314.26 140.68 313.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "139.54 312.81 139.92 313.03 139.45 313.82 139.07 313.6 139.54 312.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "138.43 312.12 138.79 312.35 138.31 313.14 137.94 312.9 138.43 312.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "137.32 311.41 137.69 311.64 137.2 312.42 136.83 312.19 137.32 311.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 135.69,
    y: 310.98,
    width: 0.92,
    height: 0.44,
    transform: "translate(-199.32 257.86) rotate(-57.34)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "134.18 309.4 134.37 309.51 133.85 310.28 133.67 310.16 134.18 309.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "132.66 308.34 132.84 308.47 132.32 309.22 132.14 309.1 132.66 308.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 130.52,
    y: 307.59,
    width: 0.92,
    height: 0.22,
    transform: "translate(-195.7 236.15) rotate(-54.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "129.65 306.19 129.83 306.32 129.28 307.06 129.1 306.94 129.65 306.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "128.16 305.09 128.33 305.23 127.78 305.96 127.61 305.83 128.16 305.09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "124.89 302.52 128.16 305.09 127.6 305.83 124.31 303.24 124.89 302.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M122.82,300.83l.79,.68c.26,.23,.54,.43,.81,.65l-.58,.71c-.27-.22-.55-.42-.82-.65l-.79-.69,.59-.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "121.74 299.89 122.27 300.35 121.68 301.05 121.14 300.59 121.74 299.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "120.74 299.02 121.01 299.25 120.4 299.95 120.14 299.71 120.74 299.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "120.05 298.42 120.31 298.65 119.7 299.34 119.44 299.11 120.05 298.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "119.35 297.82 119.62 298.05 119 298.73 118.74 298.5 119.35 297.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "118.67 297.2 118.92 297.44 118.3 298.12 118.05 297.88 118.67 297.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "117.09 295.7 117.34 295.94 116.71 296.61 116.46 296.36 117.09 295.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "115.14 293.83 115.39 294.07 114.75 294.73 114.49 294.49 115.14 293.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "112.22 290.84 114.13 292.84 113.48 293.49 111.56 291.48 112.22 290.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M109.75,288.22c.22,.27,.46,.52,.7,.77l.72,.76-.67,.63-.73-.76c-.24-.25-.48-.51-.71-.78l.68-.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "108.19 286.42 109.06 287.42 108.37 288.03 107.5 287.03 108.19 286.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "106.77 284.78 107.21 285.28 106.51 285.88 106.07 285.38 106.77 284.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M105.76,283.59c.13,.18,.28,.34,.42,.51l-.71,.59c-.15-.17-.29-.33-.43-.51l.71-.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "105.08 282.73 105.35 283.07 104.64 283.65 104.36 283.31 105.08 282.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "104.27 281.69 104.54 282.04 103.82 282.61 103.55 282.26 104.27 281.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "103.45 280.66 103.72 281 103 281.57 102.73 281.22 103.45 280.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "102.64 279.62 102.91 279.97 102.18 280.53 101.91 280.18 102.64 279.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M101.84,278.58c.09,.12,.17,.24,.26,.35l-.74,.55c-.09-.11-.17-.24-.26-.35l.74-.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "101.08 277.51 101.33 277.87 100.59 278.41 100.34 278.05 101.08 277.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "99.68 275.54 99.81 275.72 99.06 276.25 98.93 276.07 99.68 275.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "98.61 274.04 98.74 274.21 97.98 274.73 97.85 274.55 98.61 274.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "97.59 272.49 97.71 272.67 96.94 273.18 96.82 273 97.59 272.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 95.81,
    y: 271.16,
    width: 0.92,
    height: 0.22,
    transform: "translate(-131.2 94.88) rotate(-32.67)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "95.6 269.38 95.71 269.56 94.93 270.05 94.81 269.86 95.6 269.38"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M93.47,265.8l1.04,1.8c.18,.3,.34,.61,.53,.9l.56,.88-.78,.49-.56-.88c-.19-.29-.35-.6-.53-.9l-1.04-1.82,.8-.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "92.14 263.48 93.17 265.28 92.38 265.74 91.33 263.92 92.14 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "91.45 262.23 91.77 262.85 90.97 263.29 90.64 262.66 91.45 262.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "90.85 261.05 91.01 261.36 90.2 261.79 90.04 261.47 90.85 261.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "90.43 260.23 90.59 260.54 89.77 260.96 89.61 260.65 90.43 260.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "90.01 259.41 90.17 259.72 89.35 260.14 89.19 259.83 90.01 259.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "89.59 258.59 89.75 258.9 88.93 259.31 88.77 259 89.59 258.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "88.62 256.64 88.77 256.96 87.94 257.35 87.79 257.03 88.62 256.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 86.7,
    y: 254.35,
    width: 0.92,
    height: 0.35,
    transform: "translate(-97.11 58.51) rotate(-24.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M85.84,250.35c.32,.86,.71,1.7,1.09,2.54l-.84,.37c-.38-.84-.77-1.69-1.1-2.56l.85-.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "84.52 247 85.29 248.95 84.43 249.29 83.66 247.33 84.52 247"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "83.67 244.78 83.89 245.4 84.13 246.02 83.27 246.34 83.02 245.72 82.81 245.09 83.67 244.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "82.98 242.72 83.19 243.35 82.32 243.65 82.11 243.02 82.98 242.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "82.48 241.24 82.69 241.87 81.82 242.16 81.6 241.53 82.48 241.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "82.12 240.2 82.27 240.61 81.39 240.89 81.25 240.48 82.12 240.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M81.72,238.95c.04,.14,.07,.28,.12,.42l-.88,.27c-.05-.14-.08-.28-.13-.42l.88-.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "81.36 237.68 81.48 238.1 80.6 238.37 80.48 237.94 81.36 237.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "81 236.42 81.12 236.84 80.24 237.09 80.12 236.67 81 236.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "80.64 235.15 80.76 235.57 79.87 235.82 79.75 235.4 80.64 235.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "80.28 233.89 80.4 234.31 79.51 234.55 79.39 234.12 80.28 233.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "79.7 231.55 79.74 231.76 78.85 231.98 78.8 231.77 79.7 231.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 78.4,
    y: 229.85,
    width: 0.92,
    height: 0.22,
    transform: "translate(-49.66 23.6) rotate(-12.99)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "78.86 227.94 78.91 228.15 78.01 228.35 77.96 228.14 78.86 227.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "78.47 226.13 78.51 226.35 77.61 226.53 77.57 226.31 78.47 226.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "78.15 224.31 78.19 224.53 77.28 224.7 77.24 224.48 78.15 224.31"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "77.42 220.22 78.15 224.31 77.24 224.48 76.51 220.36 77.42 220.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "77.08 217.56 77.34 219.63 76.43 219.76 76.16 217.68 77.08 217.56"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 76.02,
    y: 216.2,
    width: 0.92,
    height: 0.7,
    transform: "translate(-26.7 11.38) rotate(-7.25)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.73 214.83 76.77 215.18 75.86 215.28 75.82 214.93 76.73 214.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.61 213.92 76.66 214.27 75.74 214.36 75.7 214.02 76.61 213.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.53 213 76.55 213.35 75.64 213.44 75.61 213.09 76.53 213"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.46 212.09 76.48 212.44 75.57 212.52 75.54 212.17 76.46 212.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 75.39,
    y: 209.95,
    width: 0.92,
    height: 0.35,
    transform: "translate(-15.72 6.36) rotate(-4.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.09 207.22 76.11 207.57 75.2 207.62 75.17 207.27 76.09 207.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "75.97 203.05 76.04 205.81 75.12 205.85 75.05 203.07 75.97 203.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M75.91,199.45c-.03,.7,0,1.39,.02,2.09h-.92c-.01-.69-.05-1.39-.02-2.09h.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "75.97 197.06 75.94 198.39 75.02 198.37 75.05 197.04 75.97 197.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.03 194.9 76.01 195.56 75.09 195.53 75.11 194.86 76.03 194.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.07 193.33 76.05 193.99 75.13 193.95 75.15 193.29 76.07 193.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.15 192.24 76.12 192.67 75.2 192.62 75.23 192.18 76.15 192.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.25 190.92 76.22 191.36 75.3 191.3 75.33 190.86 76.25 190.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 75.66,
    y: 189.33,
    width: 0.44,
    height: 0.92,
    transform: "translate(-119.12 251.09) rotate(-85.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.45 188.3 76.42 188.74 75.5 188.66 75.53 188.22 76.45 188.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.55 186.99 76.52 187.43 75.6 187.34 75.63 186.9 76.55 186.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "76.7 185.68 76.65 186.12 75.73 186.02 75.79 185.58 76.7 185.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 76.43,
    y: 182.88,
    width: 0.22,
    height: 0.92,
    transform: "translate(-115.02 236.03) rotate(-82.72)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "77.24 181.46 77.21 181.67 76.3 181.54 76.33 181.33 77.24 181.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "77.5 179.62 77.46 179.84 76.55 179.7 76.59 179.48 77.5 179.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "77.82 177.8 77.78 178.02 76.88 177.86 76.92 177.65 77.82 177.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "78.15 175.98 78.11 176.2 77.2 176.03 77.24 175.81 78.15 175.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M78.97,171.9c-.15,.68-.33,1.35-.45,2.03l-.37,2.05-.91-.17,.37-2.06c.13-.69,.31-1.36,.46-2.04l.9,.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "79.57 169.3 79.1 171.32 78.2 171.12 78.67 169.08 79.57 169.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "79.89 167.9 79.73 168.59 78.84 168.37 79 167.68 79.89 167.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "80.22 166.62 80.12 166.96 79.23 166.73 79.33 166.39 80.22 166.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "80.47 165.74 80.38 166.07 79.49 165.84 79.58 165.5 80.47 165.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "80.72 164.85 80.63 165.19 79.74 164.95 79.84 164.61 80.72 164.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "80.97 163.97 80.88 164.3 79.99 164.05 80.09 163.72 80.97 163.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "81.57 161.87 81.47 162.21 80.59 161.94 80.69 161.6 81.57 161.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "82.39 159.3 82.28 159.63 81.41 159.35 81.52 159.01 82.39 159.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "83.73 155.34 82.85 157.96 81.98 157.66 82.87 155.03 83.73 155.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "85.03 151.99 84.27 153.93 83.41 153.61 84.18 151.65 85.03 151.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "85.91 149.77 85.42 151 84.57 150.66 85.06 149.42 85.91 149.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "86.76 147.78 86.49 148.38 85.64 148.02 85.92 147.41 86.76 147.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "87.4 146.35 87.13 146.95 86.29 146.58 86.56 145.98 87.4 146.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "87.86 145.35 87.68 145.75 86.84 145.37 87.02 144.97 87.86 145.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "88.4 144.15 88.22 144.55 87.39 144.16 87.57 143.76 88.4 144.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M88.95,142.96c-.07,.13-.13,.26-.19,.39l-.83-.4c.06-.13,.12-.27,.19-.4l.83,.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "89.55 141.79 89.35 142.18 88.52 141.77 88.72 141.38 89.55 141.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "90.15 140.62 89.95 141 89.13 140.59 89.33 140.2 90.15 140.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "90.75 139.45 90.55 139.83 89.73 139.41 89.93 139.02 90.75 139.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M91.86,137.3c-.04,.06-.07,.13-.11,.19l-.81-.44c.03-.07,.07-.13,.11-.19l.81,.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "92.78 135.7 92.67 135.89 91.87 135.44 91.98 135.25 92.78 135.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "93.7 134.09 93.59 134.28 92.8 133.82 92.9 133.63 93.7 134.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "94.62 132.49 94.51 132.68 93.72 132.21 93.83 132.02 94.62 132.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "95.6 130.92 95.48 131.1 94.69 130.62 94.81 130.43 95.6 130.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "97.84 127.41 95.6 130.92 94.81 130.43 97.07 126.9 97.84 127.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M99.35,125.21c-.4,.57-.82,1.12-1.19,1.7l-.76-.51c.38-.59,.8-1.14,1.2-1.72l.76,.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 99.25,
    y: 123.6,
    width: 0.7,
    height: 0.92,
    transform: "translate(-59.23 133.33) rotate(-54.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "100.95 122.97 100.75 123.25 100 122.71 100.2 122.42 100.95 122.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "101.48 122.22 101.28 122.5 100.54 121.96 100.74 121.67 101.48 122.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "102.01 121.47 101.81 121.75 101.07 121.2 101.28 120.92 102.01 121.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "102.58 120.74 102.37 121.02 101.63 120.46 101.85 120.19 102.58 120.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 103.28,
    y: 118.42,
    width: 0.35,
    height: 0.92,
    transform: "translate(-53.94 126.74) rotate(-51.83)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "105.6 116.9 105.38 117.18 104.67 116.6 104.89 116.32 105.6 116.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "108.31 113.73 106.51 115.82 105.8 115.23 107.62 113.13 108.31 113.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M110.7,111.04c-.24,.25-.48,.5-.72,.76l-.68,.79-.69-.61,.69-.79c.23-.26,.48-.51,.72-.76l.68,.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "112.35 109.32 111.44 110.27 110.76 109.64 111.68 108.68 112.35 109.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "113.84 107.75 113.39 108.23 112.73 107.58 113.19 107.1 113.84 107.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "114.95 106.64 114.47 107.1 113.82 106.44 114.3 105.99 114.95 106.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "115.75 105.88 115.43 106.18 114.79 105.52 115.1 105.22 115.75 105.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 116,
    y: 104.33,
    width: 0.44,
    height: 0.92,
    transform: "translate(-40.21 109.16) rotate(-43.64)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "117.65 104.07 117.33 104.37 116.7 103.7 117.02 103.39 117.65 104.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "118.6 103.16 118.28 103.46 117.66 102.78 117.98 102.48 118.6 103.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "119.58 102.28 119.25 102.56 118.63 101.88 118.96 101.59 119.58 102.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "120.57 101.42 120.24 101.7 119.63 101.01 119.96 100.73 120.57 101.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "122.4 99.84 122.23 99.98 121.63 99.28 121.8 99.14 122.4 99.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M123.8,98.63c-.06,.04-.11,.09-.17,.14l-.59-.71c.06-.05,.11-.1,.17-.14l.59,.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "125.25 97.48 125.08 97.62 124.5 96.9 124.68 96.77 125.25 97.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "126.71 96.34 126.53 96.48 125.97 95.75 126.14 95.62 126.71 96.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "128.16 95.2 127.99 95.33 127.43 94.6 127.61 94.46 128.16 95.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M131.53,92.76l-1.69,1.21c-.56,.4-1.14,.79-1.67,1.23l-.56-.73c.54-.44,1.12-.83,1.69-1.24l1.71-1.21,.53,.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "133.71 91.21 132.02 92.41 131.49 91.66 133.19 90.45 133.71 91.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "134.91 90.43 134.32 90.81 133.81 90.04 134.4 89.66 134.91 90.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "136.02 89.72 135.73 89.9 135.23 89.13 135.52 88.94 136.02 89.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 136.23,
    y: 88.47,
    width: 0.35,
    height: 0.92,
    transform: "translate(-26.42 87.67) rotate(-32.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "137.57 88.72 137.28 88.91 136.79 88.13 137.08 87.94 137.57 88.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "138.35 88.23 138.05 88.42 137.56 87.63 137.86 87.44 138.35 88.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "140.21 87.1 139.91 87.27 139.43 86.48 139.74 86.31 140.21 87.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "142.55 85.75 142.25 85.92 141.79 85.13 142.1 84.95 142.55 85.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M146.21,83.74l-1.23,.63c-.41,.2-.8,.45-1.2,.68l-.45-.81c.4-.23,.8-.47,1.21-.68l1.24-.63,.43,.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "149.41 82.1 147.56 83.05 147.14 82.23 149.01 81.27 149.41 82.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "151.56 81.07 150.36 81.62 149.96 80.79 151.17 80.24 151.56 81.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "153.54 80.18 152.94 80.45 152.55 79.61 153.16 79.34 153.54 80.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "154.96 79.53 154.36 79.8 153.99 78.96 154.6 78.69 154.96 79.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "155.97 79.08 155.57 79.26 155.21 78.41 155.61 78.23 155.97 79.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "157.18 78.58 156.78 78.74 156.42 77.89 156.83 77.73 157.18 78.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "158.41 78.1 158 78.26 157.66 77.41 158.07 77.25 158.41 78.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 159.04,
    y: 76.81,
    width: 0.44,
    height: 0.92,
    transform: "translate(-17.24 63.78) rotate(-21.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "160.86 77.14 160.45 77.3 160.12 76.44 160.53 76.28 160.86 77.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "162.08 76.65 161.67 76.81 161.35 75.95 161.76 75.79 162.08 76.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "164.36 75.88 164.15 75.95 163.85 75.08 164.06 75.01 164.36 75.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "166.11 75.28 165.91 75.35 165.62 74.48 165.83 74.41 166.11 75.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "167.87 74.69 167.66 74.76 167.38 73.88 167.59 73.81 167.87 74.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "169.64 74.16 169.43 74.22 169.16 73.34 169.38 73.28 169.64 74.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 171.08,
    y: 72.78,
    width: 0.22,
    height: 0.92,
    transform: "translate(-13.5 49.55) rotate(-15.85)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M175.43,72.56c-.34,.08-.68,.15-1.01,.24l-1,.28-2,.57-.25-.89,2.01-.57,1.01-.29c.34-.09,.68-.16,1.02-.24l.22,.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "178.04 71.96 176.01 72.43 175.79 71.54 177.83 71.07 178.04 71.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "179.43 71.64 178.75 71.8 178.55 70.9 179.24 70.74 179.43 71.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "180.72 71.34 180.38 71.42 180.19 70.52 180.54 70.44 180.72 71.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "181.63 71.17 181.28 71.23 181.1 70.33 181.45 70.27 181.63 71.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "182.53 71.01 182.19 71.07 182.01 70.17 182.36 70.11 182.53 71.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "183.44 70.85 183.09 70.91 182.92 70.01 183.27 69.94 183.44 70.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "185.58 70.47 185.24 70.53 185.09 69.62 185.43 69.56 185.58 70.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "188.25 70.03 187.9 70.08 187.77 69.17 188.12 69.12 188.25 70.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "192.39 69.51 189.65 69.86 189.53 68.94 192.29 68.59 192.39 69.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "195.97 69.16 193.89 69.32 193.8 68.4 195.89 68.24 195.97 69.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "198.35 68.97 197.03 69.08 196.96 68.16 198.29 68.06 198.35 68.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "200.51 68.81 199.85 68.86 199.8 67.94 200.46 67.89 200.51 68.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "202.07 68.76 201.41 68.78 201.37 67.86 202.04 67.84 202.07 68.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "203.17 68.74 202.74 68.75 202.71 67.83 203.15 67.82 203.17 68.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 204.04,
    y: 67.79,
    width: 0.44,
    height: 0.92,
    transform: "translate(-1.67 5.2) rotate(-1.45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "205.8 68.67 205.37 68.68 205.35 67.76 205.79 67.75 205.8 68.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "207.12 68.64 206.68 68.65 206.68 67.73 207.12 67.72 207.12 68.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "208.43 68.66 208 68.64 208 67.72 208.44 67.73 208.43 68.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "209.75 68.69 209.31 68.68 209.33 67.76 209.77 67.77 209.75 68.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "212.16 68.75 211.94 68.74 211.97 67.82 212.19 67.83 212.16 68.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "214.01 68.8 213.79 68.79 213.84 67.87 214.06 67.88 214.01 68.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "215.86 68.93 215.64 68.91 215.69 67.99 215.91 68.01 215.86 68.93"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 217.17,
    y: 68.49,
    width: 0.92,
    height: 0.22,
    transform: "translate(132.75 280.41) rotate(-85.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "219.55 69.21 219.33 69.19 219.41 68.28 219.63 68.29 219.55 69.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M223.68,69.67c-1.38-.16-2.75-.39-4.13-.46l.08-.92c1.4,.07,2.78,.3,4.16,.46l-.11,.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "226.33 70 224.27 69.74 224.39 68.83 226.46 69.09 226.33 70"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M227.75,70.2c-.23-.05-.46-.08-.69-.1l.14-.91c.23,.03,.47,.06,.7,.1l-.14,.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "229.05 70.43 228.71 70.37 228.86 69.46 229.2 69.52 229.05 70.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "229.96 70.59 229.61 70.53 229.77 69.63 230.11 69.69 229.96 70.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "230.86 70.76 230.52 70.69 230.68 69.79 231.03 69.85 230.86 70.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "231.77 70.92 231.42 70.86 231.59 69.95 231.94 70.01 231.77 70.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "233.92 71.3 233.57 71.24 233.75 70.34 234.1 70.4 233.92 71.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "236.55 71.91 236.21 71.83 236.41 70.93 236.75 71.01 236.55 71.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M240.61,72.86c-.89-.24-1.79-.42-2.69-.64l.21-.9c.9,.22,1.81,.4,2.71,.64l-.23,.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "244.07 73.85 242.07 73.28 242.31 72.39 244.33 72.96 244.07 73.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "246.37 74.5 245.09 74.14 245.36 73.26 246.64 73.62 246.37 74.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "248.42 75.19 247.8 74.97 248.08 74.1 248.71 74.31 248.42 75.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "249.9 75.69 249.28 75.48 249.57 74.6 250.2 74.82 249.9 75.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "250.95 76.04 250.53 75.9 250.83 75.03 251.25 75.17 250.95 76.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "252.19 76.46 251.78 76.32 252.09 75.45 252.51 75.6 252.19 76.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "253.42 76.92 253.02 76.76 253.34 75.9 253.75 76.06 253.42 76.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "254.65 77.41 254.24 77.24 254.57 76.38 254.98 76.55 254.65 77.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "255.87 77.89 255.46 77.73 255.8 76.87 256.21 77.03 255.87 77.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "257.09 78.37 256.69 78.21 257.03 77.36 257.44 77.52 257.09 78.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "259.32 79.29 259.12 79.2 259.49 78.35 259.69 78.44 259.32 79.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "261.01 80.05 260.81 79.96 261.18 79.12 261.38 79.21 261.01 80.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "262.7 80.81 262.5 80.72 262.88 79.89 263.08 79.98 262.7 80.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "264.38 81.58 264.18 81.49 264.58 80.66 264.78 80.75 264.38 81.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "266.03 82.42 265.83 82.32 266.24 81.49 266.44 81.59 266.03 82.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "269.73 84.31 266.03 82.42 266.44 81.6 270.17 83.5 269.73 84.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "272.06 85.63 270.26 84.59 270.7 83.79 272.51 84.83 272.06 85.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "273.3 86.34 272.69 85.99 273.15 85.2 273.76 85.55 273.3 86.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "274.45 87 274.14 86.83 274.61 86.04 274.92 86.21 274.45 87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "275.24 87.46 274.94 87.29 275.41 86.5 275.72 86.67 275.24 87.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "276.03 87.94 275.73 87.75 276.21 86.97 276.51 87.16 276.03 87.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "276.8 88.44 276.51 88.25 276.99 87.46 277.29 87.65 276.8 88.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 278.28,
    y: 88.96,
    width: 0.92,
    height: 0.35,
    transform: "translate(53.26 275.68) rotate(-57.33)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "280.91 91.07 280.62 90.88 281.13 90.12 281.43 90.31 280.91 91.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "284.32 93.49 282.07 91.89 282.59 91.13 284.86 92.74 284.32 93.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M287.21,95.63c-.55-.43-1.08-.87-1.66-1.26l.55-.74c.58,.39,1.12,.84,1.67,1.27l-.56,.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "289.08 97.1 288.04 96.29 288.61 95.56 289.66 96.38 289.08 97.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "290.79 98.44 290.27 98.03 290.85 97.32 291.37 97.73 290.79 98.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "291.98 99.45 291.48 99.02 292.07 98.31 292.57 98.75 291.98 99.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "292.81 100.17 292.48 99.89 293.08 99.19 293.41 99.47 292.81 100.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 293.48,
    y: 100.33,
    width: 0.92,
    height: 0.44,
    transform: "translate(25.49 256.89) rotate(-49.1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "294.8 101.9 294.47 101.61 295.08 100.92 295.41 101.21 294.8 101.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "295.8 102.76 295.47 102.47 296.08 101.79 296.42 102.08 295.8 102.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "296.75 103.66 296.43 103.36 297.06 102.68 297.38 102.99 296.75 103.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "297.7 104.57 297.39 104.27 298.02 103.6 298.33 103.9 297.7 104.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "299.45 106.24 299.29 106.08 299.93 105.43 300.09 105.58 299.45 106.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "300.77 107.53 300.62 107.37 301.27 106.72 301.42 106.88 300.77 107.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "302.05 108.87 301.9 108.71 302.56 108.07 302.71 108.23 302.05 108.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "303.32 110.21 303.17 110.05 303.84 109.42 303.99 109.58 303.32 110.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "304.6 111.55 304.45 111.39 305.13 110.77 305.28 110.93 304.6 111.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M307.33,114.69c-.91-1.04-1.81-2.1-2.73-3.14l.68-.62c.93,1.04,1.83,2.11,2.75,3.16l-.7,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M309.07,116.71c-.43-.54-.9-1.05-1.35-1.58l.7-.6c.45,.53,.92,1.05,1.36,1.59l-.71,.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "309.96 117.84 309.52 117.29 310.24 116.71 310.67 117.26 309.96 117.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 310.57,
    y: 118.28,
    width: 0.92,
    height: 0.35,
    transform: "translate(-6.68 217.62) rotate(-38.18)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "311.34 119.6 311.13 119.33 311.85 118.76 312.07 119.04 311.34 119.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "311.91 120.33 311.69 120.05 312.42 119.49 312.64 119.77 311.91 120.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "312.48 121.05 312.26 120.77 313 120.22 313.21 120.5 312.48 121.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "313.76 122.81 313.56 122.53 314.3 121.98 314.51 122.27 313.76 122.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "315.33 125.01 315.13 124.73 315.88 124.2 316.08 124.49 315.33 125.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M317.66,128.48l-.75-1.16c-.25-.39-.49-.78-.77-1.15l.76-.52c.28,.37,.52,.76,.77,1.16l.75,1.17-.77,.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "319.6 131.51 318.48 129.75 319.25 129.26 320.39 131.03 319.6 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "320.81 133.56 320.15 132.41 320.94 131.94 321.61 133.09 320.81 133.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "321.89 135.44 321.56 134.87 322.36 134.41 322.69 134.99 321.89 135.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "322.67 136.79 322.34 136.22 323.15 135.77 323.48 136.35 322.67 136.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M323.21,137.76c-.07-.13-.13-.26-.2-.39l.81-.44c.08,.13,.14,.26,.2,.39l-.81,.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "323.81 138.93 323.61 138.54 324.42 138.11 324.62 138.5 323.81 138.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "324.41 140.1 324.21 139.71 325.02 139.29 325.22 139.68 324.41 140.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "325.01 141.27 324.81 140.88 325.63 140.46 325.83 140.86 325.01 141.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "325.61 142.44 325.41 142.05 326.23 141.64 326.43 142.03 325.61 142.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "326.18 143.62 326 143.22 326.83 142.82 327.01 143.22 326.18 143.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "327.17 145.82 327.08 145.62 327.92 145.24 328.01 145.44 327.17 145.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "327.94 147.5 327.85 147.31 328.69 146.94 328.78 147.14 327.94 147.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "328.69 149.2 328.61 148.99 329.46 148.63 329.54 148.84 328.69 149.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "329.37 150.92 329.29 150.71 330.14 150.37 330.22 150.57 329.37 150.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "330.04 152.64 329.96 152.44 330.82 152.1 330.9 152.31 330.04 152.64"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M331.49,156.54c-.23-.65-.43-1.32-.68-1.96l-.76-1.93,.86-.33,.77,1.95c.26,.65,.46,1.32,.69,1.98l-.87,.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "332.35 159.07 331.68 157.1 332.55 156.8 333.22 158.78 332.35 159.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "332.81 160.42 332.58 159.76 333.46 159.48 333.69 160.15 332.81 160.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "333.2 161.69 333.1 161.35 333.98 161.08 334.08 161.42 333.2 161.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "333.45 162.57 333.36 162.24 334.24 161.97 334.33 162.31 333.45 162.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "333.7 163.46 333.61 163.12 334.49 162.86 334.59 163.2 333.7 163.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "333.95 164.34 333.86 164.01 334.74 163.75 334.84 164.09 333.95 164.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "334.55 166.44 334.45 166.11 335.34 165.87 335.44 166.21 334.55 166.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "335.2 169.06 335.12 168.72 336.01 168.5 336.09 168.84 335.2 169.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "336.14 173.13 335.52 170.44 336.41 170.23 337.04 172.94 336.14 173.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "336.8 176.67 336.43 174.61 337.33 174.44 337.7 176.51 336.8 176.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "337.22 179.01 336.98 177.71 337.89 177.56 338.12 178.87 337.22 179.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "337.54 181.16 337.46 180.5 338.37 180.37 338.46 181.03 337.54 181.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "337.74 182.71 337.66 182.05 338.57 181.93 338.65 182.59 337.74 182.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    x: 337.85,
    y: 183.31,
    width: 0.92,
    height: 0.44,
    transform: "translate(-20.43 44.11) rotate(-7.24)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.05 185.11 337.99 184.67 338.9 184.57 338.96 185 338.05 185.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.21 186.41 338.16 185.98 339.07 185.88 339.13 186.32 338.21 186.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.33 187.72 338.29 187.28 339.21 187.2 339.24 187.63 338.33 187.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.43 189.03 338.39 188.6 339.31 188.52 339.34 188.96 338.43 189.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.53 190.34 338.49 189.91 339.41 189.84 339.44 190.28 338.53 190.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.71 192.75 338.69 192.53 339.61 192.48 339.63 192.7 338.71 192.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.79 194.6 338.78 194.38 339.7 194.34 339.71 194.56 338.79 194.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.83 196.45 338.83 196.23 339.75 196.2 339.75 196.42 338.83 196.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.88 198.3 338.87 198.08 339.8 198.06 339.8 198.28 338.88 198.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac",
    points: "338.93 200.15 338.92 199.93 339.84 199.93 339.85 200.15 338.93 200.15"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M161.84,182.66c.06,11.31-9.05,20.53-20.36,20.59-11.31,.06-20.53-9.06-20.59-20.36-.06-11.31,9.05-20.53,20.36-20.59,11.31-.06,20.53,9.06,20.59,20.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M141.37,183.64c-12.1,.07-21.9-.29-21.91-.81,0-.51,9.8-.98,21.9-1.05,12.1-.07,21.9,.3,21.91,.81,0,.51-9.8,.98-21.9,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M140.43,182.71c-.07-12.1,.29-21.9,.81-21.91,.51,0,.98,9.8,1.05,21.9,.07,12.1-.29,21.9-.81,21.91-.51,0-.98-9.8-1.05-21.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M36.71,352.28s0,8.06-8.06,8.06c3.49,0,8.06,2.06,8.06,7.89,0-5.83,5.98-7.89,8.06-7.89-7.83,0-8.06-8.06-8.06-8.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M55.81,309.29s0,28.56-28.56,28.56c12.38,0,28.56,7.3,28.56,27.94,0-20.64,21.18-27.94,28.56-27.94-27.74,0-28.56-28.56-28.56-28.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M55.81,318.17s0,19.58-19.58,19.58c8.49,0,19.58,5,19.58,19.15,0-14.15,14.52-19.15,19.58-19.15-19.01,0-19.58-19.58-19.58-19.58Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransaction);
export default __webpack_public_path__ + "static/media/iconTransaction.d194a9536d86f61f793d9c29c8ff0f52.svg";
export { ForwardRef as ReactComponent };